<!-- C:\Users\keiho\Documents\development\codes\doucan\vue_doucan_cms\src\h5\doucan\pages\admin/template.vue -->
<template>
  <div>
    <MyNavBar style="position:fixed;top: 0;width: 100%" title="远程指导记录"/>
    <div style="margin-top: 56px">

      <div style="margin-top: 56px">
        <!-- 日期选择区域 -->
        <div class="date-picker-bar">
          <van-cell
            :value="startDate"
            title="开始日期"
            is-link
            @click="showStartPicker = true"
          />
          <van-cell
            :value="endDate"
            title="结束日期"
            is-link
            @click="showEndPicker = true"
          />
          <van-button type="primary" size="small" style="margin: 8px 16px" block @click="onSearch">查询</van-button>
        </div>

        <!-- loading -->
        <div v-if="loading" style="text-align: center;margin-top: 16px">
          <van-loading/>
        </div>

        <div v-if="datas && !loading" style="padding: 16px 16px 0">
          <div style="font-size: 20px">查询结果: {{ datas.length }} 条</div>
        </div>

        <van-cell-group v-if="groupedData && !loading">
          <div v-for="(monthData, month) in groupedData" :key="month">
            <div
              style="display: flex;justify-content: space-between;padding: 0 16px 0 16px;font-size: 18px;font-weight: bold">
              <div>{{ month }}</div>
              <div>本月数据（{{ monthData.length }}条）</div>
            </div>
            <van-cell
              v-for="(item, index) in monthData"
              :key="index"
              :title="`日期: ${item.startTime}`"
              @click="onItemClick(item)"
            >
              <template #label>
                <div>{{ item.mdtId ? `MDT: ${item.mdtName}` : `一对一: ${item.patient} - ${item.doctor}` }}</div>
                <div class="video-tag-row">
                  <van-tag v-if="item.videoUrl" type="success" plain>有录像</van-tag>
                  <van-tag v-else type="default" plain>无录像</van-tag>
                  <van-button
                    v-if="item.videoUrl"
                    size="mini"
                    type="info"
                    plain
                    class="copy-btn"
                    @click.stop="onCopyLink(item)"
                  >复制链接</van-button>
                </div>
              </template>
            </van-cell>
            <div style="height: 16px;background-color: #eeeeee;margin-bottom: 16px"></div>
          </div>
        </van-cell-group>

        <div v-if="datas && datas.length === 0 && !loading" style="text-align: center;padding: 32px;color: #999">
          该时间段内没有记录
        </div>

        <!-- 日期选择弹窗 -->
        <van-popup v-model="showStartPicker" position="bottom">
          <van-datetime-picker
            v-model="startDateObj"
            type="date"
            title="选择开始日期"
            :max-date="maxDate"
            @confirm="onStartConfirm"
            @cancel="showStartPicker = false"
          />
        </van-popup>
        <van-popup v-model="showEndPicker" position="bottom">
          <van-datetime-picker
            v-model="endDateObj"
            type="date"
            title="选择结束日期"
            :max-date="maxDate"
            @confirm="onEndConfirm"
            @cancel="showEndPicker = false"
          />
        </van-popup>

      </div>
    </div>
  </div>
</template>
<script>
import MyNavBar from '../../components/MyNavBar'
import AdminHospitalDao from '@/h5/doucan/network/AdminHospitalDao'
import { Toast, DatetimePicker, Popup } from 'vant'

export default {
  name: 'AdminHospitalRemoteGuideList',
  components: {
    MyNavBar,
    'van-datetime-picker': DatetimePicker,
    'van-popup': Popup
  },
  data () {
    const now = new Date()
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
    return {
      datas: null,
      groupedData: null,
      isAdmin: false,
      loading: false,
      startDate: this.formatDate(firstDay),
      endDate: this.formatDate(now),
      startDateObj: firstDay,
      endDateObj: now,
      maxDate: now,
      showStartPicker: false,
      showEndPicker: false
    }
  },
  mounted () {
    this.isAdmin = this.$route.query.isAdmin === 'true'
    this.onSearch()
  },
  methods: {
    formatDate (date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    onStartConfirm (val) {
      this.startDate = this.formatDate(val)
      this.startDateObj = val
      this.showStartPicker = false
    },
    onEndConfirm (val) {
      this.endDate = this.formatDate(val)
      this.endDateObj = val
      this.showEndPicker = false
    },
    async onSearch () {
      if (this.startDate > this.endDate) {
        Toast('开始日期不能晚于结束日期')
        return
      }
      this.loading = true
      this.datas = null
      this.groupedData = null
      try {
        const datas = await AdminHospitalDao.remoteGuideList(this.isAdmin, this.startDate, this.endDate)
        this.datas = datas || []
        this.buildGroupedData()
      } catch (e) {
        console.error(e)
        Toast.fail('查询失败')
        this.datas = []
      }
      this.loading = false
    },
    buildGroupedData () {
      const groupedData = {}
      this.datas.forEach(item => {
        const itemDate = new Date(item.date)
        const month = `${itemDate.getFullYear()}-${String(itemDate.getMonth() + 1).padStart(2, '0')}`
        if (!groupedData[month]) {
          groupedData[month] = []
        }
        groupedData[month].push(item)
      })
      this.groupedData = groupedData
    },
    getVideoUrl (url) {
      if (!url) return ''
      return url.replace(/agora-docan/g, 'ihealthy')
    },
    onItemClick (item) {
      if (!item.videoUrl) {
        Toast('该记录没有录像')
        return
      }
      window.open(this.getVideoUrl(item.videoUrl), '_blank')
    },
    onCopyLink (item) {
      if (!item.videoUrl) return
      const url = this.getVideoUrl(item.videoUrl)
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          Toast.success('链接已复制')
        }).catch(() => {
          this.fallbackCopy(url)
        })
      } else {
        this.fallbackCopy(url)
      }
    },
    fallbackCopy (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        Toast.success('链接已复制')
      } catch (e) {
        Toast.fail('复制失败，请手动复制')
      }
      document.body.removeChild(textarea)
    }
  }
}
</script>
<style scoped>
.date-picker-bar {
  background: #fff;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}
.video-tag-row {
  display: flex;
  align-items: center;
  margin-top: 6px;
  gap: 8px;
}
.copy-btn {
  height: 22px;
  padding: 0 6px;
  font-size: 11px;
}
</style>
